<template>
	<div class="row">
		<div class="col-12 col-md-12 mt-3">
			<div class="col-12 p-0">
				<div class="row">
					<div class="col-12 col-md-12">
						<div class="row">
							<div class="col-9 offset-1 col-md-12 ml-0 ml-md-0">
								<!-- <ul class="pagination float-md-left">
									<li>
										<a class="page-link rounded-left" href="#" aria-label="Previous">
											<span aria-hidden="true"><i class="fas fa-angle-double-left"></i></span>
										</a>
									</li>
									<li>
										<a class="page-link" href="#" aria-label="Previous">
											<span aria-hidden="true"><i class="fas fa-angle-left"></i></span>
										</a>
									</li>
									<li class="cursor-pointer"><span class="page-link active">1</span></li>
									<li class="cursor-pointer"><span class="page-link">2</span></li>
									<li>
										<a class="page-link" href="#">
											<span aria-hidden="true"><i class="fas fa-angle-right"></i></span>
										</a>
									</li>
									<li>
										<a class="page-link rounded-right" href="#">
											<span aria-hidden="true"><i class="fas fa-angle-double-right"></i></span>
										</a>
									</li>
								</ul> -->
								<ul class="pagination float-md-left">
									<li  v-if="pagination.first_page == true" @click="gotoPage(1)">
										<a class="page-link rounded-left" href="#" aria-label="Previous">
											<span aria-hidden="true"><i class="fas fa-angle-double-left"></i></span>
										</a>
									</li>
									<li @click="gotoPage(pagination.prev)">
										<a class="page-link" href="#" aria-label="Previous" v-show="pagination.prev > 0">
											<span aria-hidden="true"><i class="fas fa-angle-left"></i></span>
										</a>
									</li>
									<li @click="gotoPage(value)" class="cursor-pointer" v-for="value in pagination.detail" :key="value"><span class="page-link" :class="{active:value==pagination.current}">{{value}}</span></li>
									<li @click="gotoPage(pagination.next)">
										<a class="page-link" href="#"  v-show="pagination.next > 0">
											<span aria-hidden="true"><i class="fas fa-angle-right"></i></span>
										</a>
									</li>
									<li v-if="pagination.last_page == true" @click="gotoPage(pagination.total_page)">
										<a class="page-link rounded-right" href="#">
											<span aria-hidden="true"><i class="fas fa-angle-double-right"></i></span>
										</a>
									</li>
								</ul>
								<ul class="pagination float-md-right">
                  <li>
                    <a class="page-link bg-blue color-white rounded-left" href="#" aria-label="Previous" @click="refresh(pagination.current)">
                      <span aria-hidden="true" class="font-size-10"><i class="fas fa-sync-alt mr-1"></i>Refresh</span>
                    </a>
                  </li>
                  <li class="">
                    <div class="btn-group">
                      <a type="button" class="page-link background-purple dropdown-toggle background-white rounded-right" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <span class="font-size-10">{{limit}}</span>
                        <div class="dropdown-menu drop-pagination dropdown-menu-right">
                          <span @click="changeLimit(lim)" v-for="lim in arr_limit" :key="lim" class="dropdown-item pl-0 pr-0 text-center link-black font-size-10">{{lim}}</span>
                        </div>
                      </a>
                    </div>
                  </li>
                </ul>
								<!-- <ul class="pagination float-md-right">
									<li>
										<a class="page-link bg-blue color-white rounded-left" href="#" aria-label="Previous">
											<span aria-hidden="true" class="font-size-10"><i class="fas fa-sync-alt mr-1"></i>Refresh</span>
										</a>
									</li>
									<li class="">
										<div class="btn-group">
											<a type="button" class="page-link background-purple dropdown-toggle background-white rounded-right" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
												<span class="font-size-10">10</span>
												<div class="dropdown-menu drop-pagination dropdown-menu-right">
													<span class="dropdown-item pl-0 pr-0 text-center link-black font-size-10">50</span>
													<span class="dropdown-item pl-0 pr-0 text-center link-black font-size-10">200</span>
												</div>
											</a>
										</div>
									</li>
								</ul> -->
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
		data() {
			return {
				arr_limit : [10, 20, 30, 50, 100]
			}
		},
	props: {
		pagination: {
			type: Object,
			default: function () {
				return {
					total_data: 0,
					total_page: 4,
					total_display: 10,
					prev: 0,
					current: 1,
					next: 2,
					first_page: false,
          last_page: false,
					detail:[1, 2, 3, 4]
				}
			}
		},
		limit : {
			type : Number,
			default: 10,
		},
	},
	methods: {
		gotoPage(val){
			this.$emit('gotoPage', val)
		},
		refresh(val){
			this.$emit('refresh', val)
		},
		changeLimit(val){
			this.$emit('changeLimit', val)
		},
	}
};
</script>

<style scoped>
.page-link {
	border: none;
	color: #545554;
	font-size: 10pt;
}
.page-link:hover {
	background-color: #5d22ac;
	color: #fff;
}
.page-link:focus {
	background-color: #5d22ac;
	color: #fff;
	box-shadow: none;
}
.page-link.active {
	background-color: #5d22ac;
	color: #fff;
}
.pagination .color-white {
	color: #fff;
}
.dropdown-menu.drop-pagination {
	max-width: 3rem;
	min-width: 3rem;
}
.dropdown-menu.drop-pagination .dropdown-item:hover,
.dropdown-menu.drop-pagination .dropdown-item:active,
.dropdown-menu.drop-pagination .dropdown-item:focus {
	background-color: #5d22ac;
	border: none;
	color: #fff;
}
</style>
